import MainInformationViewer from './shopProfile/MainInformationViewer';
import GeographyViewer from './shopProfile/GeographyViewer';
import ProductCatalogViewer from './shopProfile/ProductCatalogViewer';
import PricingViewer from './shopProfile/PricingViewer';
import AudienceViewer from './shopProfile/AudienceViewer';
import BrandPositioningViewer from './shopProfile/BrandPositioningViewer';
import KeywordsViewer from './shopProfile/KeywordsViewer';
import { EmptyState } from './shopProfile/primitives';

const VIEWER_BY_TAB = {
  'main-information': MainInformationViewer,
  'geography-market-coverage': GeographyViewer,
  'product-catalog-structure': ProductCatalogViewer,
  'pricing-commercial-position': PricingViewer,
  'target-audience': AudienceViewer,
  'brand-positioning': BrandPositioningViewer,
  'keywords-market-language': KeywordsViewer,
};

const ShopProfileViewer = ({ report, tabKey }) => {
  const Viewer = VIEWER_BY_TAB[tabKey];
  if (!Viewer) return <EmptyState />;
  return <Viewer report={report} />;
};

export default ShopProfileViewer;
